import { c as _c } from "react/compiler-runtime";
import { useId } from "react";
import { cn } from "@/utilities/core/cn";
type PlayerAvatarSize = "xs" | "sm" | "md" | "lg" | "xl" | "xl2" | "xl3";
const SIZE_MAP: Record<PlayerAvatarSize, number> = {
  xs: 16,
  sm: 20,
  md: 32,
  lg: 48,
  xl: 64,
  xl2: 80,
  xl3: 96
};
const BORDER_COLOR = "#B0B0B0";
const DEFAULT_BG = "#E5E7EB";
const DEFAULT_FG = "#9CA3AF";
interface PlayerAvatarProps {
  /** Background tint (e.g. player country color). Falls back to neutral gray. */
  primaryColor?: string | null;
  size?: PlayerAvatarSize;
  className?: string;
}
export function PlayerAvatar(t0) {
  const $ = _c(18);
  const {
    primaryColor,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const px = SIZE_MAP[size];
  const bg = primaryColor || DEFAULT_BG;
  const clipId = useId();
  let t2;
  if ($[0] !== className) {
    t2 = cn("shrink-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <circle cx="50" cy="50" r="47" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== clipId) {
    t4 = <defs><clipPath id={clipId}>{t3}</clipPath></defs>;
    $[3] = clipId;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== bg) {
    t5 = <circle cx="50" cy="50" r="47" fill={bg} />;
    $[5] = bg;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `url(#${clipId})`;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <circle cx="50" cy="40" r="14" fill={DEFAULT_FG} />;
    t8 = <path d="M24 90 C24 72, 36 62, 50 62 C64 62, 76 72, 76 90 L76 100 L24 100 Z" fill={DEFAULT_FG} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t6) {
    t9 = <g clipPath={t6}>{t7}{t8}</g>;
    $[9] = t6;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <circle cx="50" cy="50" r="47" fill="none" stroke={BORDER_COLOR} strokeWidth="2.5" />;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== px || $[13] !== t2 || $[14] !== t4 || $[15] !== t5 || $[16] !== t9) {
    t11 = <svg width={px} height={px} viewBox="0 0 100 100" className={t2} aria-hidden="true">{t4}{t5}{t9}{t10}</svg>;
    $[12] = px;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}